import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'rp_technik',
} as IModuleProps;
